import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import {
  Button,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import Select from "react-select";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";
import {
  getPartAutoTempList,
  getVehicleProcessDetails,
  getvehicleMakeAllList,
  getvehicleYearList,
} from "../../services/VehicleService";
import { getVehicleAllModalSerachList } from "../../services/VehicleModelService";
import { getVehicleSerachVariantList } from "../../services/VehicleVariantsService";
import { useTranslation } from "react-i18next";
import {
  getCatalogList,
  getStructureOem,
  getVerifyFilterDetails,
  getvehicleCompatibleProduct,
  getvehicleProductDetails,
} from "../../services/PartsInventory";
import { profileDetailForWeb } from "../../services/AuthServices";
import Utils from "../../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const AutoFillVehicle = ({ partsByPhotoData, vehicleData }) => {
  const { t } = useTranslation();
  const LangData = localStorage.getItem("lng");
  const navigate = useNavigate();

  const [key, setKey] = useState("part_name");
  const [VehicleTypePartList, setVehicleTypePartList] = useState([]);
  const [inputSelctedTypeValue, setInputSelctedTypeValue] = useState([]);
  const [categoryPartsData, setCategoryPartsData] = useState({
    vehicle_year: "",
    vehicle_make: "",
    vehicle_model: "",
    vehicle_variant: "",
    is_master_id: "",
    vehicle_make_name: "",
    vehicle_model_name: "",
    vehicle_variant_name: "",
    vehicle_type: "",
  });
  const [vehicleMakePartList, setvehicleMakePartList] = useState([]);
  const [inputSelctedMakeValue, setInputSelctedMakeValue] = useState("");
  const [vehicleModalPartList, setvehicleModalPartList] = useState([]);
  const [inputSelctedModalValue, setInputSelctedModalValue] = useState("");
  const [vehicleVariantPartList, setvehicleVariantPartList] = useState([]);
  const [inputSelctedVariantValue, setInputSelctedVariantValue] = useState("");
  const [vehicleYearPartList, setvehicleYearPartList] = useState([]);
  const [inputSelctedYearValue, setInputSelctedYearValue] = useState("");
  const [selectedVehicleData, setSelectedVehicleData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [inputSelctedValue, setInputSelctedValue] = useState("");
  const [categoryPartList, setCategoryPartList] = useState([]);
  const [partData, setPartData] = useState({
    catalog_id: "",
    namePartPT: "",
    description: "",
  });
  const [selectedPartData, setSelectedPartData] = useState([]);

  const [isPartEditing, setIsPartEditing] = useState(false);
  const [editPartIndex, setEditPartIndex] = useState(null);
  const [loadingStructureOem, setLoadingStructureOem] = useState(false);
  const [modifyOemModal, setModifyOemModal] = useState(false);
  const [profileDetails, setProfileDetails] = useState("");
  const [structureOemList, setStructureOemList] = useState([]);
  const [selectedReferencesData, setSelectedReferencesData] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [modifyConfirmModal, setModifyConfirmModal] = useState(false);
  const [selectedOEMIndices, setSelectedOEMIndices] = useState([]);
  const [productVehicleId, setProductVehicleId] = useState([]);
  const [modifyProductModal, setModifyProductModal] = useState(false);
  const [vehicleCompatibleProductList, setVehicleCompatibleProductList] =
    useState([]);

  const [vehicleCompatibleProductDetails, setVehicleCompatibleProductDetails] =
    useState([]);
  const [selectedVehicleOEMData, setSelectedVehicleOEMData] = useState({
    iem_list: [],
    oem_list: [],
    vehicle_compatible_list: [],
  });
  const [vehicleSelectedComDataList, setVehicleSelectedComDataList] = useState(
    []
  );
  const [loadingCompatible, setLoadingCompatible] = useState(false);
  const [VehicleTypeList, setVehicleTypeList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [VehicleYearList, setVehicleYearList] = useState([]);
  const [vehiclePartsData, setVehiclePartsData] = useState({
    vehicle_model_id: "",
    vehicle_make: "",
    vehicle_year: "",
    vehicle_model: "",
    vehicle_variants: "",
    vehicle_parts_id: "",
    vehicle_type: "",
    notes: "",
  });

  const [VehicleMakeList, setVehicleMakeList] = useState([]);
  const [inputSelctedeMakeValue, setInputSelctedeMakeValue] = useState("");
  const [VehicleModalList, setVehicleModalList] = useState([]);
  const [inputSelctedeModalValue, setInputSelctedeModalValue] = useState("");
  const [VehicleVariantList, setVehicleVariantList] = useState([]);
  const [inputSelctededVariantValue, setInputSelctededVariantValue] =
    useState("");
  const [inputSelctedeYearValue, setinputSelctedeYearValue] = useState("");
  const [partsData, setPartsData] = useState({ parts_associate: [] });

  const [selectedRows, setSelectedRows] = useState({
    part_catalog: [],
    parts_reference: [],
    parts_associate: [],
    vehicle: [],
  });
  const [finalPartsData, setFinalPartsData] = useState({ part_list: [] });
  const [finalVehicleData, setFinalVehicleData] = useState({ part_list: [] });
  const [vehiclePartDetails, setVehiclePartDetails] = useState([]);
  const [isFound, setIsFound] = useState("");

  useEffect(() => {
    if (vehicleData?.state?.item?.vehicleId) {
      let data = {
        vehicle_id: vehicleData?.state?.item?.vehicleId,
        data_type: "vehicle",
      };

      getVehicleProcessDetails(data)
        .then((response) => {
          setVehiclePartDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehicleData?.state?.item?.vehicleId]);

  useEffect(() => {
    const vehicleList = Array.isArray(selectedRows?.vehicle)
      ? selectedRows.vehicle
      : selectedRows?.vehicle
      ? [selectedRows.vehicle]
      : [];

    if (vehicleList.length && selectedRows?.part_catalog?.length) {
      const finalVehicles = selectedRows.part_catalog.flatMap((catalog) =>
        vehicleList.map((vehicle) => ({
          catalog_id: catalog.catalog_id,
          namePartPT: catalog.namePartPT,
          vehicle_make: vehicle.make_id,
          vehicle_make_name: vehicle.vehicle_make,
          vehicle_model: vehicle.vehicle_model_id,
          vehicle_model_name: vehicle.vehicle_model_name,
          vehicle_variant_name: vehicle.vehicle_variant_name,
          variants_id: vehicle.vehicle_variant_id,
          vehicle_year: vehicle.vehicle_year,
          vehicle_type_id: vehicle?.vehicle_type_id,
          vehicle_type_name: vehicle?.vehicle_type,

          parts_associate: selectedRows?.parts_associate?.map((v) => ({
            vehicle_type: v.vehicle_type,
            vehicle_year: v.vehicle_year,
            vehicle_make: v.vehicle_make,
            vehicle_model: v.vehicle_model,
            vehicle_variant: v.vehicle_variant || 0,
            notes: v.notes || "",
          })),
          parts_reference: selectedRows?.parts_reference?.map((item) => ({
            reference_code: item?.referenceCode,
            is_main: 0,
            type_id: item?.type_id,
            condition_id_ref: item?.condition_id,
            
          })),
        }))
      );

      setFinalPartsData({ part_list: finalVehicles });
    }
  }, [selectedRows]);

  useEffect(() => {
    const vehicleList = Array.isArray(selectedRows?.vehicle)
      ? selectedRows.vehicle
      : selectedRows?.vehicle
      ? [selectedRows.vehicle]
      : [];

    if (selectedRows?.part_catalog?.length) {
      const finalVehicles = selectedRows.part_catalog.flatMap((catalog) =>
        (vehicleList.length ? vehicleList : [{}]).map((vehicle) => ({
          catalog_id: catalog.catalog_id,
          namePartPT: catalog.namePartPT,

          vehicle_make: vehiclePartDetails?.make_id ?? vehicle?.make_id ?? null,
          vehicle_make_name:
            vehiclePartDetails?.vehicle_make_name ??
            vehicle?.vehicle_make ??
            "",

          vehicle_model:
            vehiclePartDetails?.vehicle_model_id ??
            vehicle?.vehicle_model_id ??
            null,
          vehicle_model_name:
            vehiclePartDetails?.vehicle_model_name ??
            vehicle?.vehicle_model_name ??
            "",

          vehicle_variant_name:
            vehiclePartDetails?.variants_name ??
            vehicle?.vehicle_variant_name ??
            "",
          variants_id:
            vehiclePartDetails?.variants_id ??
            vehicle?.vehicle_variant_id ??
            null,

          initial_year:
            vehiclePartDetails?.vehicle_year ?? vehicle?.vehicle_year ?? null,

          vehicle_type_id:
            vehiclePartDetails?.vehicle_type ??
            vehiclePartDetails?.vehicle_type_id ??
            vehicle?.vehicle_type_id ??
            null,
          vehicle_type_name:
            vehiclePartDetails?.vehicle_type_name ??
            vehicle?.vehicle_type ??
            "",

          parts_associate:
            selectedRows?.parts_associate?.map((v) => ({
              vehicle_type_name: v.vehicle_type?.label ?? "",
              vehicle_year: v.vehicle_year?.value ?? "",
              make_name: v.vehicle_make?.label ?? "",
              model_name: v.vehicle_model?.label ?? "",
              variant_name: v.vehicle_variant?.label ?? 0,
              vehicle_type: v.vehicle_type?.value ?? null,
              make_id: v.vehicle_make?.value ?? null,
              model_id: v.vehicle_model?.value ?? null,
              vehicle_variant: v.vehicle_variant?.value ?? null,
              notes: v.notes || "",
            })) || [],

          parts_reference:
            selectedRows?.parts_reference?.map((item) => ({
              reference_code: item?.referenceCode ?? "",
              is_main: 0,
              type_id: item?.type_id ?? null,
              condition_id_ref: item?.condition_id ?? null,
            })) || [],

          vehicleId: vehicleData?.state?.item?.vehicleId ?? null,
        }))
      );

      setFinalVehicleData({ part_list: finalVehicles });
    }
  }, [selectedRows]);

  const handleCompatibleCheck = (variantID) => {
    const isSelected = selectedVehicleOEMData?.vehicle_compatible_list?.some(
      (item) => item.variantID === variantID
    );

    const selectedItem = vehicleCompatiblesList.find(
      (item) => item.variantID === variantID
    );

    if (!selectedItem) return;

    setSelectedVehicleOEMData((prev) => {
      const currentList = prev?.vehicle_compatible_list || [];

      return {
        ...prev,
        vehicle_compatible_list: isSelected
          ? currentList.filter((item) => item.variantID !== variantID)
          : [...currentList, selectedItem],
      };
    });
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const vehicleCompatiblesList =
    vehicleCompatibleProductList?.length > 0
      ? vehicleCompatibleProductList
      : structureOemList?.decode?.vehiclesCompatibles || [];

  const handleAddOrUpdate = () => {
    const vehicle = {
      vehicle_type: VehicleTypePartList.find(
        (item) => item.value === categoryPartsData.vehicle_type
      )?.label,
      vehicle_year: categoryPartsData.vehicle_year,
      vehicle_make: vehicleMakePartList.find(
        (item) => item.value === categoryPartsData.vehicle_make
      )?.label,
      vehicle_model_name: vehicleModalPartList.find(
        (item) => item.value === categoryPartsData.vehicle_model
      )?.label,
      vehicle_variant_name:
        vehicleVariantPartList.find(
          (item) => item.value === categoryPartsData.vehicle_variant
        )?.label || "",
      vehicle_model_id: categoryPartsData.vehicle_model,
      vehicle_variant_id: categoryPartsData.vehicle_variant || 0,
      vehicle_year: categoryPartsData.vehicle_year,
    };

    const newEntry = {
      vehicle_year: categoryPartsData.vehicle_year,
      vehicle_variant_id: categoryPartsData.vehicle_variant || 0,
      vehicle_model_id: categoryPartsData.vehicle_model,
      vehicle,
    };

    if (isEditing) {
      const updatedList = [...selectedVehicleData];
      updatedList[editIndex] = newEntry;
      setSelectedVehicleData(updatedList);
      setIsEditing(false);
      setEditIndex(null);
    } else {
      setSelectedVehicleData((prev) => [...prev, newEntry]);
    }

    // Optionally reset form
    setCategoryPartsData({
      vehicle_type: null,
      vehicle_year: null,
      vehicle_make: null,
      vehicle_model: null,
      vehicle_variant: null,
    });
  };

  const handleDelete = (index) => {
    const updated = selectedVehicleData.filter((_, i) => i !== index);
    setSelectedVehicleData(updated);
  };

  const handleEdit = (index) => {
    const row = selectedVehicleData[index];
    setIsEditing(true);
    setEditIndex(index);
    setCategoryPartsData({
      vehicle_type:
        VehicleTypePartList.find(
          (item) => item.label === row.vehicle.vehicle_type
        )?.value || null,
      vehicle_year: row.vehicle.vehicle_year,
      vehicle_make:
        vehicleMakePartList.find(
          (item) => item.label === row.vehicle.vehicle_make
        )?.value || null,
      vehicle_model:
        vehicleModalPartList.find(
          (item) => item.label === row.vehicle.vehicle_model_name
        )?.value || null,
      vehicle_variant:
        vehicleVariantPartList.find(
          (item) => item.label === row.vehicle.vehicle_variant_name
        )?.value || null,
    });
  };

  const handleAddOrUpdatePart = () => {
    const selectedCatalog = categoryPartList.find(
      (item) => item.value === partData.catalog_id
    );

    if (!selectedCatalog) return;

    const catalog = {
      namePartPT: selectedCatalog.label,
      weight: selectedCatalog.weight || "0",
      length: selectedCatalog.length || "0",
      width: selectedCatalog.width || "0",
      height: selectedCatalog.height || "0",
      urlImage: selectedCatalog.urlImage || "",
      inventory_count: selectedCatalog.inventory_count || "0",
      part_type_name: selectedCatalog.part_type_name || "",
    };

    const newEntry = {
      id: partData.catalog_id,
      description: partData.description || "",
      catalog,
    };

    if (isPartEditing) {
      const updatedList = [...selectedPartData];
      updatedList[editPartIndex] = newEntry;
      setSelectedPartData(updatedList);
      setIsPartEditing(false);
      setEditPartIndex(null);
    } else {
      setSelectedPartData((prev) => [...prev, newEntry]);
    }

    // Reset form
    setPartData({
      catalog_id: null,
      description: "",
    });
  };
  const handlePartDelete = (index) => {
    const updated = selectedPartData.filter((_, i) => i !== index);
    setSelectedPartData(updated);
  };

  const handlePartEdit = (index) => {
    const row = selectedPartData[index]; // <- Corrected this
    setIsPartEditing(true);
    setEditPartIndex(index);

    setPartData({
      catalog_id: row.id,
      description: row.description || "",
    });
  };

  useEffect(function () {
    getAllVehicleSerachType()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(
    function () {
      if (productVehicleId?.productID) {
        const obj = {
          productID: productVehicleId?.productID,
          language: LangData ? LangData : "PT",
          country: profileDetails?.company_details?.state,
          regNumberCompany:
            profileDetails?.company_details?.company_registration_number,
        };
        getvehicleProductDetails(obj)
          .then((response) => {
            setVehicleCompatibleProductDetails(response.data.data);
          })
          .catch((err) => {});
      }
    },
    [productVehicleId]
  );

  useEffect(() => {
    profileDetailForWeb()
      .then((response) => {
        setProfileDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (partsByPhotoData) {
      setSelectedVehicleData(partsByPhotoData?.decode?.vehicle_catalog);
      setSelectedPartData(partsByPhotoData?.decode?.parts_catalog);
      setSelectedReferencesData(partsByPhotoData?.decode?.references);
      if (partsByPhotoData?.decode?.vehicle_compatibles) {
        const mappedAssociates =
          partsByPhotoData.decode.vehicle_compatibles.map((item) => {
            const vehicle = item.vehicle || {};
            return {
              vehicle_type: {
                value: parseInt(vehicle.vehicle_type_id),
                label: vehicle.vehicle_type,
              },
              vehicle_year: {
                value: parseInt(item.vehicle_year),
                label: item.vehicle_year,
              },
              vehicle_make: {
                value: parseInt(vehicle.make_id),
                label: vehicle.vehicle_make,
              },
              notes: item.notes || "", // if exists

              vehicle_variant: {
                value: parseInt(vehicle.veriant_id),
                label: vehicle.vehicle_variant_name,
              },
              vehicle_model: {
                value: parseInt(vehicle.vehicle_model_id),
                label: vehicle.vehicle_model_name,
              },
            };
          });

        setPartsData((prev) => ({
          ...prev,
          parts_associate: mappedAssociates,
        }));
      }
    }
  }, [partsByPhotoData]);

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypePartList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeVehicleTypeList = (inputSelctedTypeValue) => {
    setInputSelctedTypeValue(inputSelctedTypeValue);

    if (inputSelctedTypeValue.length > 0) {
      const obj = {
        search: inputSelctedTypeValue,
        limit: 20,
        page: 1,
      };

      getAllVehicleSerachType(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].vehicle_type_name,
            });
          }
          setVehicleTypePartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeTypeList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_type: option.value,
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: "",
      vehicle_year: "",
    }));
    setvehicleMakePartList([]);
    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);
    setvehicleYearPartList([]);
  };

  useEffect(function () {
    var obj = {
      search: "",
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setvehicleYearPartList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeYearList = (inputSelctedYearValue) => {
    setInputSelctedYearValue(inputSelctedYearValue);

    const obj = {
      search: inputSelctedYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setvehicleYearPartList(list);
      })
      .catch((err) => {});
  };

  const handleSelectWithoutChangeYearList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_year: option.value,
    }));

    setvehicleMakePartList([]);
    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);

    if (option) {
      const obj = {
        type: "year",
        search: option?.value,
        value: categoryPartsData?.vehicle_make,
      };

      getVerifyFilterDetails(obj)
        .then((response) => {
          const isFound = response.data.is_found;

          if (isFound === 1) {
            setCategoryPartsData((prevData) => ({
              ...prevData,
              vehicle_year: option.value,
              vehicle_make: categoryPartsData?.vehicle_make,
              vehicle_model: categoryPartsData?.vehicle_model,
              vehicle_variant: categoryPartsData?.vehicle_variant,
              is_master_id: categoryPartsData?.is_master_id,
              vehicle_make_name: categoryPartsData?.vehicle_make_name,
              vehicle_model_name: categoryPartsData?.vehicle_model_name,
              vehicle_variant_name: categoryPartsData?.vehicle_variant_name,
              vehicle_type: categoryPartsData?.vehicle_type,
            }));
          } else {
            setCategoryPartsData((prevData) => ({
              ...prevData,
              vehicle_year: option.value,
              vehicle_make: "",
              vehicle_model: "",
              vehicle_variant: "",
              vehicle_make_name: "",
              vehicle_model_name: "",
              vehicle_variant_name: "",
            }));
          }
        })
        .catch((err) => {
          console.error("Error checking is_found:", err);
        });
    }
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_year) {
        var obj = {
          search: "",
          limit: 20,
          page: 1,
          year: categoryPartsData?.vehicle_year,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getvehicleMakeAllList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].description,
              });
            }
            setvehicleMakePartList(list);
          })
          .catch((err) => {});
      }
    },

    [categoryPartsData?.vehicle_year]
  );

  const handleInputSelectedChangeMakeList = (inputSelctedMakeValue) => {
    setInputSelctedMakeValue(inputSelctedMakeValue);

    if (inputSelctedMakeValue.length > 0) {
      const obj = {
        search: inputSelctedMakeValue,
        limit: 20,
        page: 1,
        year: categoryPartsData?.vehicle_year,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getvehicleMakeAllList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].description,
            });
          }
          setvehicleMakePartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeMakeList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_make: option.value,
      vehicle_make_name: option.label,
    }));

    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);

    if (option) {
      const obj = {
        type: "make",
        search: option?.value,
        value: categoryPartsData?.vehicle_model,
      };

      getVerifyFilterDetails(obj)
        .then((response) => {
          const isFound = response.data.is_found;

          if (isFound === 1) {
            setCategoryPartsData((prevData) => ({
              ...prevData,
              vehicle_make: option.value,
              vehicle_make_name: option.label,
            }));
          } else {
            setCategoryPartsData((prevData) => ({
              ...prevData,
           
              vehicle_model: "",
              vehicle_variant: "",
              vehicle_make_name: "",
              vehicle_model_name: "",
              vehicle_variant_name: "",
            }));
          }
        })
        .catch((err) => {
          console.error("Error checking is_found:", err);
        });
    }
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_make) {
        var obj = {
          search: "",
          limit: 20,
          page: 1,
          vehicle_year: categoryPartsData?.vehicle_year,
          make_id: categoryPartsData?.vehicle_make,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getVehicleAllModalSerachList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].description,
              });
            }
            setvehicleModalPartList(list);
          })
          .catch((err) => {});
      }
    },
    [categoryPartsData?.vehicle_make]
  );

  const handleInputSelectedChangeModelList = (inputSelctedModalValue) => {
    setInputSelctedModalValue(inputSelctedModalValue);

    if (inputSelctedModalValue.length > 0) {
      const obj = {
        search: inputSelctedModalValue,
        limit: 20,
        page: 1,
        vehicle_year: categoryPartsData?.vehicle_year,
        make_id: categoryPartsData?.vehicle_make,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getVehicleAllModalSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].model_name,
            });
          }
          setvehicleModalPartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeModelList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_model: option.value,
      vehicle_model_name: option.label,
    }));
    setvehicleVariantPartList([]);

    if (option) {
      const obj = {
        type: "model",
        search: option?.value,
        value: categoryPartsData?.vehicle_variant,
      };

      getVerifyFilterDetails(obj)
        .then((response) => {
          const isFound = response.data.is_found;

          if (isFound === 1) {
            setCategoryPartsData((prevData) => ({
              ...prevData,
              vehicle_model: option.value,
              vehicle_model_name: option.label,
            }));
          } else {
            setCategoryPartsData((prevData) => ({
              ...prevData,
           
              vehicle_variant: "",
              vehicle_make_name: "",
              vehicle_variant_name: "",
            }));
          }
        })
        .catch((err) => {
          console.error("Error checking is_found:", err);
        });
    }
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_model) {
        var obj = {
          search: "",
          limit: 20,
          page: 1,
          vehicle_year: categoryPartsData?.vehicle_year,
          model_id: categoryPartsData?.vehicle_model,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getVehicleSerachVariantList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].variants_name,
              });
            }
            setvehicleVariantPartList(list);
          })
          .catch((err) => {});
      }
    },
    [categoryPartsData?.vehicle_model]
  );

  const handleInputSelectedChangeVariantList = (inputSelctedVariantValue) => {
    setInputSelctedVariantValue(inputSelctedVariantValue);

    if (inputSelctedVariantValue.length > 0) {
      const obj = {
        serach: inputSelctedVariantValue,
        limit: 20,
        page: 1,
        vehicle_year: categoryPartsData?.vehicle_year,
        model_id: categoryPartsData?.vehicle_model,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getVehicleSerachVariantList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].variants_name,
            });
          }
          setvehicleVariantPartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeVariantList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_variant: option.value,
      vehicle_variant_name: option.label,
    }));
  };

  useEffect(() => {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
      vehicle_type_id: 0,
    };

    getCatalogList(obj)
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].namePartPT,
            height: response.data[i].height,
            width: response.data[i].width,
            weight: response.data[i].weight,
            length: response.data[i].length,
            urlImage: response.data[i].urlImage,
            part_type_name: response.data[i].part_type_name,
          });
        }

        // Add selectedPartData entries if missing from API list
        const existingIds = new Set(list.map((item) => item.value));

        selectedPartData.forEach((item) => {
          if (!existingIds.has(item.id)) {
            list.push({
              value: item.id,
              label: item.catalog.namePartPT,
              height: item.catalog.height,
              width: item.catalog.width,
              weight: item.catalog.weight,
              length: item.catalog.length,
              urlImage: item.catalog.urlImage,
              part_type_name: item.catalog.part_type_name,
            });
          }
        });

        setCategoryPartList(list);
      })
      .catch((err) => {});
  }, [categoryPartsData?.vehicle_type, selectedPartData]);

  const handleInputSelectedChangeCategoryList = (inputSelctedValue) => {
    setInputSelctedValue(inputSelctedValue);

    if (inputSelctedValue.length > 0) {
      const obj = {
        search: inputSelctedValue,
        limit: 20,
        page: 1,
      };

      getCatalogList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].namePartPT,
              height: response.data[i].height,
              width: response.data[i].width,
              weight: response.data[i].weight,
              length: response.data[i].length,
              urlImage: response.data[i].urlImage,
              part_type_name: response.data[i].part_type_name,
            });
          }
          setCategoryPartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeCategoryList = (option) => {
    setPartData((prevData) => ({
      ...prevData,
      catalog_id: option.value,
    }));
  };

  const handleOemRefSubmit = (e, item) => {
    if (item) {
      setModifyOemModal(true);
      setLoadingStructureOem(true);

      let data = {
        // refOEM: item.referenceCode,
        refOEM: "811100H030",
        showAllVehiclesCompatibles: 1,
        language: LangData ? LangData : "PT",
        country: profileDetails?.company_details?.state,
        regNumberCompany:
          profileDetails?.company_details?.company_registration_number,
      };

      getStructureOem(data)
        .then((response) => {
          setStructureOemList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingStructureOem(false); // stop loading
        });
    }
  };

  const handleOpenProductConfirm = () => {
    if (selectedVehicleOEMData?.iem_list?.length === 0) {
      toast.error(t("please_select_at_least_one_product"));
      return;
    }
    setModifyConfirmModal(true);
  };

  const handleCheck = (productID) => {
    const isSelected = selectedVehicleOEMData?.iem_list?.some(
      (item) => item.productID === productID
    );
    const selectedItem = structureOemList?.decode?.equivalentsIAM.find(
      (item) => item.productID === productID
    );
    setSelectedVehicleOEMData((prev) => {
      const currentList = prev?.iem_list || [];
      return {
        ...prev,
        iem_list: isSelected
          ? currentList.filter((item) => item.productID !== productID)
          : [...currentList, selectedItem],
      };
    });
  };

  const handleCheckAll = () => {
    const list = structureOemList?.decode?.equivalentsIAM || [];

    setSelectedVehicleOEMData((prev) => ({
      ...prev,
      iem_list: prev.iem_list?.length === list?.length ? [] : [...list],
    }));
  };

  const handleCheckOEM = (index) => {
    const list = structureOemList?.decode?.equivalentsOEM || [];
    const selectedItem = list[index];

    if (!selectedItem) return;

    const isSelected = selectedOEMIndices.includes(index);

    const updatedIndices = isSelected
      ? selectedOEMIndices.filter((i) => i !== index)
      : [...selectedOEMIndices, index];

    setSelectedOEMIndices(updatedIndices);

    setSelectedVehicleOEMData((prev) => {
      const updatedList = isSelected
        ? prev.oem_list.filter((_, idx) => idx !== index)
        : [...prev.oem_list, selectedItem];

      return {
        ...prev,
        oem_list: updatedList,
      };
    });
  };

  const handleCheckAllOEM = () => {
    const list = structureOemList?.decode?.equivalentsOEM || [];

    const allIndices = list.map((_, i) => i);
    const isAllSelected = selectedOEMIndices.length === list.length;

    setSelectedOEMIndices(isAllSelected ? [] : allIndices);

    setSelectedVehicleOEMData((prev) => ({
      ...prev,
      oem_list: isAllSelected ? [] : [...list],
    }));
  };

  const handleChangeOemRefClose = () => {
    setModifyOemModal(false);
    setSelectedVehicleOEMData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });
    setSelectedOEMIndices([]);
  };

  const handleProductDetailsModalClose = () => {
    setModifyProductModal(false);
  };

  const handleSelectRef = () => {
    const iemMapped =
      selectedVehicleOEMData?.iem_list?.map((item) => ({
        referenceCode: item.reference,
        referenceCondition: "AFTERMARKET",
        referenceType: "COMPATIBLE",
        productID: item.productID,
      })) || [];

    const oemMapped =
      selectedVehicleOEMData?.oem_list?.map((item) => ({
        referenceCode: item.reference,
        referenceCondition: "OEM",
        referenceType: "COMPATIBLE",
      })) || [];

    const mergedRefs = [...iemMapped, ...oemMapped];

    setSelectedReferencesData((prev) => [...prev, ...mergedRefs]);

    const vehicleMapped =
      selectedVehicleOEMData?.vehicle_compatible_list?.map((item) => ({
        ...item,
      })) || [];

    const newUniqueVehicles = vehicleMapped?.filter(
      (item) =>
        !vehicleSelectedComDataList?.some(
          (existing) => existing.variantID === item.variantID
        )
    );

    setVehicleSelectedComDataList((prev) => [...prev, ...newUniqueVehicles]);

    setModifyOemModal(false);

    setSelectedVehicleOEMData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });
    setSelectedOEMIndices([]);
  };

  const handleProductConfirmClose = () => {
    setModifyConfirmModal(false);
  };

  const handleSubmitVehicleComProduct = (e) => {
    const selectedProductIds = selectedVehicleOEMData.iem_list
      ?.map((item) => item.productID)
      .join(",");

    const productId = selectedReferencesData
      ?.map((item) => item.productID)
      .join(",");

    let data = {
      productID: productId ? productId : selectedProductIds,
      language: LangData ? LangData : "PT",
      country: profileDetails?.company_details?.state,
      regNumberCompany:
        profileDetails?.company_details?.company_registration_number,
    };
    setLoadingCompatible(true);
    getvehicleCompatibleProduct(data)
      .then((response) => {
        const list = response.data.data;
        setVehicleCompatibleProductList(list);
        setPartsData((prev) => {
          if (prev.parts_associate.length === 0) {
            const mappedList = list.map((item) => ({
              vehicle_type: {
                label: item?.vehicle_type,
                value: item?.vehicle_type,
              },
              vehicle_year: {
                label: item?.vehicle_year,
                value: item?.vehicle_year,
              },
              vehicle_make: {
                label: item?.vehicle_make_description,
                value: item?.vehicle_make,
              },
              vehicle_model: {
                label: item?.vehicle_model_description,
                value: item?.vehicle_model,
              },
              vehicle_variant: {
                label: item?.vehicle_variant_description || "All",
                value: item?.vehicle_variant || "",
              },
              notes: item?.notes || "",
            }));

            return { ...prev, parts_associate: mappedList };
          }
          return prev;
        });
        setActiveTab("3");
        setModifyConfirmModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingCompatible(false);
      });
  };

  const handleVehicleChange = (selectedOption) => {
    setSelectedVehicle(selectedOption || null);
    setVehiclePartsData((prevData) => ({
      ...prevData,
      vehicle_type: selectedOption ? selectedOption.value : "",
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variants: "",
    }));
    setVehicleMakeList([]);
    setVehicleModalList([]);
    setVehicleVariantList([]);
  };

  const handleInputSelectedChangeComYearList = (inputSelctedeYearValue) => {
    setinputSelctedeYearValue(inputSelctedeYearValue);
    const obj = {
      search: inputSelctedeYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  useEffect(
    function () {
      if (vehiclePartsData?.vehicle_type) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          vehicle_type_id: vehiclePartsData?.vehicle_type,
          year: vehiclePartsData?.vehicle_year,
          is_reload: true,
        };
        getvehicleMakeAllList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.description,
              });
            }
            setVehicleMakeList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsData]
  );

  const handleInputSelectedChangeComMakeList = (inputSelctedeMakeValue) => {
    setInputSelctedeMakeValue(inputSelctedeMakeValue);
    if (inputSelctedeMakeValue.length > 0) {
      const obj = {
        limit: 20,
        page: 1,
        search: inputSelctedeMakeValue,
        vehicle_type_id: vehiclePartsData?.vehicle_type,
        year: vehiclePartsData?.vehicle_year,

        is_reload: true,
      };

      getvehicleMakeAllList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.description,
            });
          }
          setVehicleMakeList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(
    function () {
      if (vehiclePartsData?.vehicle_make) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          vehicle_year: vehiclePartsData?.vehicle_year,

          make_id: vehiclePartsData?.vehicle_make,
          vehicle_type_id: vehiclePartsData?.vehicle_type,

          is_reload: true,
        };

        getVehicleAllModalSerachList(data)
          .then((response) => {
            response = response.data;

            let list = [
              { value: "all", label: "All" },
              ...response.data.map((item) => ({
                value: item.id,
                label: item.model_name,
              })),
            ];
            setVehicleModalList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsData]
  );

  const handleInputSelectedChangeModalList = (inputSelctedeModalValue) => {
    setInputSelctedeModalValue(inputSelctedeModalValue);
    if (inputSelctedeModalValue.length > 0) {
      const obj = {
        limit: 20,
        page: 1,
        search: inputSelctedeModalValue,
        make_id: vehiclePartsData?.make_id,
        vehicle_type_id: vehiclePartsData?.vehicle_type,
        vehicle_year: vehiclePartsData?.vehicle_year,

        is_reload: true,
      };

      getVehicleAllModalSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [
            { value: "all", label: "All" },
            ...response.data.map((item) => ({
              value: item.id,
              label: item.variants_name,
            })),
          ];
          setVehicleVariantList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(
    function () {
      if (vehiclePartsData?.vehicle_model) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          model_id:
            vehiclePartsData.vehicle_model === "all"
              ? 0
              : vehiclePartsData.vehicle_model,
          vehicle_type_id: vehiclePartsData?.vehicle_type,
          vehicle_year: vehiclePartsData?.vehicle_year,

          is_reload: true,
        };
        getVehicleSerachVariantList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.variants_name,
              });
            }
            list.unshift({ value: "all", label: "All" });

            setVehicleVariantList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsData]
  );

  const handleInputSelectedChangeComVariantList = (
    inputSelctededVariantValue
  ) => {
    setInputSelctededVariantValue(inputSelctededVariantValue);
    if (inputSelctededVariantValue.length > 0) {
      const obj = {
        limit: 20,
        page: 1,
        search: inputSelctededVariantValue,
        model_id: vehiclePartsData.vehicle_model,
        vehicle_type_id: vehiclePartsData?.vehicle_type,
        vehicle_year: vehiclePartsData?.vehicle_year,

        is_reload: true,
      };

      getVehicleSerachVariantList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.variants_name,
            });
          }
          setVehicleVariantList(list);
        })
        .catch((err) => {});
    }
  };

  const handleInputChangeComp = (e) => {
    const { name, value } = e.target;
    setVehiclePartsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddCompatible = () => {
    if (!selectedVehicle) {
      toast.error(t("pi_toast_please_select_type"));
      return;
    }

    const {
      vehicle_year,
      vehicle_make,
      vehicle_model,
      vehicle_variant,
      notes,
    } = vehiclePartsData;

    if (!vehicle_year) {
      toast.error(t("pi_toast_please_select_year"));
      return;
    }

    if (!vehicle_make) {
      toast.error(t("pi_toast_please_select_make"));
      return;
    }

    const newAssociate = {
      vehicle_type: selectedVehicle,
      vehicle_year: VehicleYearList.find((item) => item.value === vehicle_year),
      vehicle_make: VehicleMakeList.find((item) => item.value === vehicle_make),
      vehicle_model: VehicleModalList.find(
        (item) => item.value === vehicle_model
      ),
      vehicle_variant: VehicleVariantList.find(
        (item) => item.value === vehicle_variant
      ),
      notes: notes || "",
    };

    setPartsData((prevData) => {
      const updated = { ...prevData };

      if (!updated.parts_associate) {
        updated.parts_associate = [];
      }

      const isDuplicate = updated.parts_associate.some((item) => {
        return (
          item.vehicle_type?.value === newAssociate.vehicle_type?.value &&
          item.vehicle_year?.value === newAssociate.vehicle_year?.value &&
          item.vehicle_make?.value === newAssociate.vehicle_make?.value &&
          item.vehicle_model?.value === newAssociate.vehicle_model?.value &&
          item.vehicle_variant?.value === newAssociate.vehicle_variant?.value
        );
      });

      if (!isDuplicate) {
        updated.parts_associate.push(newAssociate);
      }

      return updated;
    });

    setSelectedVehicle(null);
    setVehiclePartsData({
      vehicle_make: "",
      vehicle_year: "",
      vehicle_model: "",
      vehicle_variant: "",
      vehicle_parts_id: "",
      vehicle_type: "",
      notes: "",
    });

    setVehicleYearList([]);
    setVehicleMakeList([]);
    setVehicleModalList([]);
    setVehicleVariantList([]);
    setInputSelctedYearValue(null);
  };

  const handleRemoveCompatible = (itemIndex) => {
    const updatedPartsData = { ...partsData };

    if (
      updatedPartsData &&
      Array.isArray(updatedPartsData.parts_associate) &&
      updatedPartsData.parts_associate.length > itemIndex
    ) {
      updatedPartsData.parts_associate = [...updatedPartsData.parts_associate];
      updatedPartsData.parts_associate.splice(itemIndex, 1);
      setPartsData(updatedPartsData);
    } else {
      console.warn("Invalid indices for removal");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedRows?.part_catalog || selectedRows.part_catalog.length === 0) {
      toast.error(t("pi_toast_please_select_part_and_vehicle"));
      return;
    } else if (
      !selectedRows?.part_catalog ||
      selectedRows.part_catalog.length === 0
    ) {
      toast.error(t("pi_toast_please_select_one_part"));
      return;
    }

    let data;
    if (!vehicleData?.state) {
      data = {
        part_list: JSON.stringify(finalPartsData),
        temp_id: null,
      };
    } else {
      data = {
        part_list: JSON.stringify(finalVehicleData),
        temp_id: null,
      };
    }

    getPartAutoTempList(data)
      .then((response) => {
        toast.success(response.data.message);

        const dataToStore = response.data.data;
        localStorage.setItem("partFormData", JSON.stringify(dataToStore));
        if (!vehicleData?.state) {
          navigate("/parts-inventory-addparts", {
            state: partsByPhotoData,
          });
        } else {
          navigate(
            "/parts-inventory/AddParts",

            {
              state: partsByPhotoData,
            }
          );
        }
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row justify-content-start">
          <div className="col-md-12">
            <div className="card card-primary">
              <Form method={`post`}>
                <div className="card-body">
                  <div className="row justify-content-start">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="mt-4">
                          <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                          >
                            <Tab
                              eventKey="part_name"
                              title={t("part_name")}
                              style={{
                                color: "#81bb42",
                              }}
                            >
                              <div className="card">
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="vehicleThBg table-responsive-sm">
                                        <Table
                                          className="rounded-table"
                                          striped
                                          bordered
                                          hover
                                        >
                                          <thead>
                                            <tr>
                                              <th>
                                                <input
                                                  type="checkbox"
                                                  checked={
                                                    selectedPartData?.length >
                                                      0 &&
                                                    selectedRows?.part_catalog
                                                      ?.length ===
                                                      selectedPartData?.length &&
                                                    selectedPartData.every(
                                                      (row) =>
                                                        selectedRows?.part_catalog?.some(
                                                          (selected) =>
                                                            selected.catalog_id ===
                                                              row.id &&
                                                            selected.namePartPT ===
                                                              row.catalog
                                                                ?.namePartPT
                                                        )
                                                    )
                                                  }
                                                  onChange={(e) => {
                                                    if (e.target.checked) {
                                                      const allRows =
                                                        selectedPartData.map(
                                                          (row) => ({
                                                            catalog_id: row.id,
                                                            namePartPT:
                                                              row?.catalog
                                                                ?.namePartPT,
                                                          })
                                                        );
                                                      setSelectedRows({
                                                        part_catalog: allRows,
                                                      });
                                                    } else {
                                                      setSelectedRows({
                                                        part_catalog: [],
                                                      });
                                                    }
                                                  }}
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </th>

                                              <th></th>

                                              <th>
                                                <div>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          categoryPartList
                                                        }
                                                        value={
                                                          categoryPartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              partData.catalog_id
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeCategoryList
                                                        }
                                                        placeholder={
                                                          "Select Part"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeCategoryList
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </th>
                                              {/* 
                                              <th>{t("width")}</th>

                                              <th>{t("height")}</th>
                                              <th>{t("length")}</th>
                                              <th>{t("weight")}</th> */}

                                              <th>
                                                <div
                                                  className="addBtn"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={
                                                    handleAddOrUpdatePart
                                                  }
                                                >
                                                  <i
                                                    className={`bi ${
                                                      isEditing
                                                        ? "bi-pencil-square"
                                                        : "bi-plus-lg"
                                                    }`}
                                                  ></i>
                                                </div>
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {selectedPartData?.length > 0 ? (
                                              selectedPartData?.map(
                                                (row, index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      <input
                                                        type="checkbox"
                                                        checked={selectedRows?.part_catalog?.some(
                                                          (item) =>
                                                            item.catalog_id ===
                                                              row.id &&
                                                            item.namePartPT ===
                                                              row.catalog
                                                                ?.namePartPT
                                                        )}
                                                        onChange={(e) => {
                                                          const rowData = {
                                                            catalog_id: row.id,
                                                            namePartPT:
                                                              row.catalog
                                                                ?.namePartPT,
                                                          };

                                                          setSelectedRows(
                                                            (prev) => {
                                                              const existing =
                                                                prev.part_catalog ||
                                                                [];

                                                              if (
                                                                e.target.checked
                                                              ) {
                                                                if (
                                                                  !existing.some(
                                                                    (item) =>
                                                                      item.catalog_id ===
                                                                      row.id
                                                                  )
                                                                ) {
                                                                  return {
                                                                    part_catalog:
                                                                      [
                                                                        ...existing,
                                                                        rowData,
                                                                      ],
                                                                  };
                                                                }
                                                                return prev;
                                                              } else {
                                                                return {
                                                                  part_catalog:
                                                                    existing.filter(
                                                                      (item) =>
                                                                        item.catalog_id !==
                                                                        row.id
                                                                    ),
                                                                };
                                                              }
                                                            }
                                                          );
                                                        }}
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                      />
                                                    </td>

                                                    <td>
                                                      <img
                                                        src={
                                                          row?.catalog?.urlImage
                                                        }
                                                        alt=""
                                                        style={{
                                                          width: "70px",
                                                          height: "70px",
                                                        }}
                                                      />
                                                    </td>

                                                    <td
                                                      style={{
                                                        fontWeight: 900,
                                                      }}
                                                    >
                                                      {row.catalog?.namePartPT}
                                                    </td>
                                                    {/* <td>
                                                      {row.catalog?.width}
                                                    </td>
                                                    <td>
                                                      {row.catalog?.height}
                                                    </td>
                                                    <td>
                                                      {row.catalog?.length}
                                                    </td>
                                                    <td>
                                                      {row?.catalog?.weight}
                                                    </td> */}

                                                    <td
                                                      style={{
                                                        display: "flex",
                                                        marginTop: "20px",
                                                      }}
                                                    >
                                                      <i
                                                        className="bi bi-pencil-square me-2"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "#007bff",
                                                        }}
                                                        onClick={() =>
                                                          handlePartEdit(index)
                                                        }
                                                      ></i>
                                                      <i
                                                        className="bi bi-trash"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "red",
                                                        }}
                                                        onClick={() =>
                                                          handlePartDelete(
                                                            index
                                                          )
                                                        }
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="100%"
                                                  className="text-center"
                                                >
                                                  No results found
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="back-footer">
                                    <div className="back-next back-next-custom">
                                      <div className="row">
                                        <div className="col"></div>
                                        <div className="col nxt-btn mr-0">
                                          <Button
                                            className="next-button"
                                            type="button"
                                            onClick={() => {
                                              if (
                                                vehicleData?.state?.item
                                                  ?.vehicleId
                                              ) {
                                                setKey("references");
                                              } else {
                                                setKey("vehicle_catalog");
                                              }
                                            }}
                                          >
                                            {t("next")}{" "}
                                            <i className="bi bi-arrow-right"></i>
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="fuelCF">
                                    <div className="card-footer clearfix card-footer-part ">
                                      <div className="pagination pagination-sm m-0 float-right"></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tab>

                            {!vehicleData?.state?.item?.vehicleId && (
                              <Tab
                                eventKey="vehicle_catalog"
                                title={t("vehicle")}
                                style={{
                                  color: "#81bb42",
                                }}
                              >
                                <div className="card">
                                  <div className="card-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="vehicleThBg table-responsive-sm">
                                          <Table
                                            className="rounded-table"
                                            striped
                                            bordered
                                            hover
                                          >
                                            <thead>
                                              <tr>
                                                <th></th>

                                                <th></th>
                                                <th>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          VehicleTypePartList
                                                        }
                                                        value={
                                                          VehicleTypePartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData?.vehicle_type
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeTypeList
                                                        }
                                                        placeholder={
                                                          "Select Vehicle Type"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeVehicleTypeList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedTypeValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </th>

                                                <th>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          vehicleYearPartList
                                                        }
                                                        value={
                                                          vehicleYearPartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData?.vehicle_year
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeYearList
                                                        }
                                                        placeholder={
                                                          "Select Year"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeYearList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedYearValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </th>

                                                <th>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          vehicleMakePartList
                                                        }
                                                        value={
                                                          vehicleMakePartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData?.vehicle_make
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeMakeList
                                                        }
                                                        placeholder={
                                                          "Select Make"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeMakeList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedMakeValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </th>

                                                <th>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          vehicleModalPartList
                                                        }
                                                        value={
                                                          vehicleModalPartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData.vehicle_model
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeModelList
                                                        }
                                                        placeholder={
                                                          "Select modal"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeModelList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedModalValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </th>

                                                <th>
                                                  <div className="input-div SelectV">
                                                    <div className="col-md-12">
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          vehicleVariantPartList
                                                        }
                                                        value={
                                                          vehicleVariantPartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData?.vehicle_variant
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeVariantList
                                                        }
                                                        placeholder={
                                                          "Select Variant"
                                                        }
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeVariantList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedVariantValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </th>

                                                <th>
                                                  <div
                                                    className="addBtn"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={handleAddOrUpdate}
                                                  >
                                                    <i
                                                      className={`bi ${
                                                        isEditing
                                                          ? "bi-pencil-square"
                                                          : "bi-plus-lg"
                                                      }`}
                                                    ></i>
                                                  </div>
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {selectedVehicleData?.length >
                                              0 ? (
                                                selectedVehicleData?.map(
                                                  (row, index) => (
                                                    <tr key={index}>
                                                      <td>
                                                        <input
                                                          type="radio"
                                                          name="vehicle_radio"
                                                          checked={
                                                            selectedRows
                                                              ?.vehicle
                                                              ?.vehicle_model_id ===
                                                              row.vehicle
                                                                ?.vehicle_model_id &&
                                                            selectedRows
                                                              ?.vehicle
                                                              ?.vehicle_year ===
                                                              row.vehicle
                                                                ?.vehicle_year &&
                                                            selectedRows
                                                              ?.vehicle
                                                              ?.vehicle_variant_id ===
                                                              row.vehicle
                                                                ?.vehicle_variant_id
                                                          }
                                                          onChange={() => {
                                                            const rowData = {
                                                              vehicle_type_id:
                                                                row.vehicle
                                                                  ?.vehicle_type_id,
                                                              vehicle_year:
                                                                row.vehicle
                                                                  ?.vehicle_year,
                                                              make_id:
                                                                row.vehicle
                                                                  ?.make_id,
                                                              vehicle_model_id:
                                                                row.vehicle
                                                                  ?.vehicle_model_id,
                                                              vehicle_variant_id:
                                                                row.vehicle
                                                                  ?.vehicle_variant_id,

                                                              vehicle_type:
                                                                row.vehicle
                                                                  ?.vehicle_type,
                                                              vehicle_make:
                                                                row.vehicle
                                                                  ?.vehicle_make,
                                                              vehicle_model_name:
                                                                row.vehicle
                                                                  ?.vehicle_model_name,
                                                              vehicle_variant_name:
                                                                row.vehicle
                                                                  ?.vehicle_variant_name,
                                                            };

                                                            setSelectedRows(
                                                              (prev) => ({
                                                                ...prev,
                                                                vehicle:
                                                                  rowData, // Only one selected row at a time
                                                              })
                                                            );
                                                          }}
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        />
                                                      </td>

                                                      <td>
                                                        <img
                                                          src={
                                                            row?.vehicle
                                                              ?.url_image
                                                          }
                                                          alt=""
                                                          style={{
                                                            width: "70px",
                                                            height: "70px",
                                                          }}
                                                        />
                                                      </td>

                                                      <td>
                                                        {
                                                          row.vehicle
                                                            ?.vehicle_type
                                                        }
                                                      </td>
                                                      <td>
                                                        {
                                                          row.vehicle
                                                            ?.vehicle_year
                                                        }
                                                      </td>
                                                      <td>
                                                        {
                                                          row.vehicle
                                                            ?.vehicle_make
                                                        }
                                                      </td>
                                                      <td>
                                                        {
                                                          row.vehicle
                                                            ?.vehicle_model_name
                                                        }
                                                      </td>
                                                      <td>
                                                        {row.vehicle
                                                          ?.vehicle_variant_name ||
                                                          "Not available"}
                                                      </td>
                                                      <td
                                                        style={{
                                                          display: "flex",
                                                          marginTop: "25px",
                                                        }}
                                                      >
                                                        <i
                                                          className="bi bi-pencil-square me-2"
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "#007bff",
                                                          }}
                                                          onClick={() =>
                                                            handleEdit(index)
                                                          }
                                                        ></i>
                                                        <i
                                                          className="bi bi-trash"
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                          }}
                                                          onClick={() =>
                                                            handleDelete(index)
                                                          }
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan="100%"
                                                    className="text-center"
                                                  >
                                                    No results found
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="back-footer">
                                      <div className="back-next back-next-custom">
                                        <div className="row">
                                          <div className="col">
                                            {!vehicleData?.state?.item
                                              ?.vehicleId && (
                                              <button
                                                type="button"
                                                className="next-button btn btn-secondary ms-0"
                                                onClick={() => {
                                                  setKey("part_name");
                                                }}
                                              >
                                                <i className="bi bi-arrow-left"></i>{" "}
                                                {t("back")}
                                              </button>
                                            )}
                                          </div>
                                          <div className="col nxt-btn mr-0">
                                            <Button
                                              className="next-button"
                                              type="button"
                                              onClick={() =>
                                                setKey("references")
                                              }
                                            >
                                              {t("next")}{" "}
                                              <i className="bi bi-arrow-right"></i>
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="fuelCF">
                                      <div className="card-footer clearfix card-footer-part ">
                                        <div className="pagination pagination-sm m-0 float-right"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab>
                            )}

                            {/* )} */}

                            <Tab
                              eventKey="references"
                              title={t("pi_references")}
                              style={{
                                color: "#81bb42",
                              }}
                            >
                              <div className="card">
                                <div className="card-body">
                                  <div className="row">
                                    <Table
                                      className="rounded-table"
                                      striped
                                      bordered
                                      hover
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            <input
                                              type="checkbox"
                                              checked={
                                                selectedReferencesData?.length >
                                                  0 &&
                                                selectedRows?.parts_reference
                                                  ?.length >=
                                                  selectedReferencesData?.length &&
                                                selectedReferencesData?.every(
                                                  (row) =>
                                                    selectedRows?.parts_reference?.some(
                                                      (item) =>
                                                        item.referenceCode ===
                                                        row.referenceCode
                                                    )
                                                )
                                              }
                                              onChange={(e) => {
                                                setSelectedRows((prev) => {
                                                  const existing =
                                                    prev.parts_reference || [];

                                                  if (e.target.checked) {
                                                    const newRows =
                                                      selectedReferencesData.filter(
                                                        (row) =>
                                                          !existing.some(
                                                            (item) =>
                                                              item.referenceCode ===
                                                              row.referenceCode
                                                          )
                                                      );

                                                    return {
                                                      ...prev,
                                                      parts_reference: [
                                                        ...existing,
                                                        ...newRows,
                                                      ],
                                                    };
                                                  } else {
                                                    const updated =
                                                      existing.filter(
                                                        (item) =>
                                                          !selectedReferencesData.some(
                                                            (row) =>
                                                              row.referenceCode ===
                                                              item.referenceCode
                                                          )
                                                      );

                                                    return {
                                                      ...prev,
                                                      parts_reference: updated,
                                                    };
                                                  }
                                                });
                                              }}
                                            />
                                          </th>

                                          <th>{t("referenceCode")}</th>

                                          <th>{t("referenceCondition")}</th>

                                          <th>{t("referenceType")}</th>
                                          <th>{t("Action")}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {selectedReferencesData?.length > 0 ? (
                                          selectedReferencesData?.map(
                                            (row, index) => (
                                              <tr key={index}>
                                                <td>
                                                  <input
                                                    type="checkbox"
                                                    checked={selectedRows?.parts_reference?.some(
                                                      (item) =>
                                                        item.referenceCode ===
                                                        row.referenceCode
                                                    )}
                                                    onChange={(e) => {
                                                      setSelectedRows(
                                                        (prev) => {
                                                          const existing =
                                                            prev.parts_reference ||
                                                            [];

                                                          if (
                                                            e.target.checked
                                                          ) {
                                                            if (
                                                              !existing.some(
                                                                (item) =>
                                                                  item.referenceCode ===
                                                                  row.referenceCode
                                                              )
                                                            ) {
                                                              return {
                                                                ...prev,
                                                                parts_reference:
                                                                  [
                                                                    ...existing,
                                                                    row,
                                                                  ],
                                                              };
                                                            }
                                                            return prev;
                                                          } else {
                                                            return {
                                                              ...prev,
                                                              parts_reference:
                                                                existing.filter(
                                                                  (item) =>
                                                                    item.referenceCode !==
                                                                    row.referenceCode
                                                                ),
                                                            };
                                                          }
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </td>

                                                <td>{row?.referenceCode}</td>

                                                <td>
                                                  {row.referenceCondition}
                                                </td>
                                                <td>{row.referenceType}</td>

                                                <td
                                                  style={{
                                                    display: "flex",
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  <button
                                                    type="button"
                                                    className="btn btn-block btn-payment"
                                                    onClick={(e) =>
                                                      handleOemRefSubmit(e, row)
                                                    }
                                                    style={{
                                                      width: "auto",
                                                      margin: "auto",
                                                      padding: "5px 12px",
                                                    }}
                                                  >
                                                    <i
                                                      className="bi bi-car-front"
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    ></i>
                                                  </button>

                                                  {row?.productID && (
                                                    <button
                                                      type="button"
                                                      className="btn btn-block btn-payment"
                                                      onClick={(e) => {
                                                        setProductVehicleId(
                                                          row
                                                        );
                                                        setModifyProductModal(
                                                          true
                                                        );
                                                      }}
                                                      style={{
                                                        width: "auto",
                                                        margin: "auto",
                                                        padding: "5px 12px",
                                                        marginLeft: "-75px",
                                                      }}
                                                    >
                                                      <i className="bi bi-gear"></i>{" "}
                                                    </button>
                                                  )}
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="100%"
                                              className="text-center"
                                            >
                                              No results found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                  <div className="back-footer">
                                    <div className="back-next back-next-custom">
                                      <div className="row">
                                        <div className="col">
                                          <button
                                            type="button"
                                            className="next-button btn btn-secondary ms-0"
                                            onClick={() => {
                                              if (
                                                vehicleData?.state?.item
                                                  ?.vehicleId
                                              ) {
                                                setKey("part_name");
                                              } else {
                                                setKey("vehicle_catalog");
                                              }
                                            }}
                                          >
                                            <i className="bi bi-arrow-left"></i>{" "}
                                            {t("back")}
                                          </button>
                                        </div>

                                        <div className="col nxt-btn mr-0">
                                          <Button
                                            className="next-button"
                                            type="button"
                                            onClick={() =>
                                              setKey("vehicle_compatibles")
                                            }
                                          >
                                            {t("next")}{" "}
                                            <i className="bi bi-arrow-right"></i>
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tab>

                            <Tab
                              eventKey="vehicle_compatibles"
                              title={t("pi_vehicle_compatibles_tab")}
                              style={{
                                color: "#81bb42",
                              }}
                            >
                              <div className="card">
                                <div className="card-body">
                                  <div className="col-lg-12">
                                    <div
                                      className="vehicleThBg table-responsive table-responsive-sm"
                                      style={{
                                        height: "370px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Table
                                        className="rounded-table"
                                        striped
                                        bordered
                                        hover
                                      >
                                        <thead>
                                          <tr>
                                            <th>
                                              <input
                                                type="checkbox"
                                                checked={
                                                  partsData?.parts_associate
                                                    ?.length > 0 &&
                                                  selectedRows.parts_associate
                                                    ?.length ===
                                                    partsData?.parts_associate
                                                      ?.length &&
                                                  partsData?.parts_associate?.every(
                                                    (row) =>
                                                      selectedRows?.parts_associate?.some(
                                                        (selected) =>
                                                          selected.vehicle_make ===
                                                            row.vehicle_make &&
                                                          selected.vehicle_model ===
                                                            row.vehicle_model &&
                                                          selected.vehicle_variant ===
                                                            (row.vehicle_variant ||
                                                              0) &&
                                                          selected.vehicle_year ===
                                                            row.vehicle_year
                                                      )
                                                  )
                                                }
                                                onChange={(e) => {
                                                  if (e.target.checked) {
                                                    const allRows =
                                                      partsData.parts_associate.map(
                                                        (row) => ({
                                                          vehicle_type:
                                                            row.vehicle_type ||
                                                            0,
                                                          vehicle_year:
                                                            row.vehicle_year ||
                                                            0,
                                                          vehicle_make:
                                                            row.vehicle_make ||
                                                            0,
                                                          vehicle_model:
                                                            row.vehicle_model ||
                                                            0,
                                                          vehicle_variant:
                                                            row.vehicle_variant ||
                                                            0,
                                                          notes:
                                                            row.notes || "",
                                                        })
                                                      );

                                                    setSelectedRows((prev) => ({
                                                      ...prev,
                                                      parts_associate: allRows,
                                                    }));
                                                  } else {
                                                    setSelectedRows((prev) => ({
                                                      ...prev,
                                                      parts_associate: [],
                                                    }));
                                                  }
                                                }}
                                                style={{ cursor: "pointer" }}
                                              />
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <Select
                                                    className="my-select-v"
                                                    options={VehicleTypeList}
                                                    value={selectedVehicle}
                                                    onChange={
                                                      handleVehicleChange
                                                    }
                                                    isSearchable={true}
                                                    placeholder={
                                                      "Select Vehicle Types"
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <Select
                                                    className="my-select-v"
                                                    options={VehicleYearList}
                                                    value={
                                                      VehicleYearList.find(
                                                        (item) =>
                                                          item.value ==
                                                          vehiclePartsData.vehicle_year
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      setVehiclePartsData(
                                                        (prev) => ({
                                                          ...prev,
                                                          vehicle_year:
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "",
                                                          vehicle_make: "",
                                                          vehicle_model: "",
                                                          vehicle_variant: "",
                                                        })
                                                      );
                                                      setVehicleMakeList([]);
                                                      setVehicleModalList([]);
                                                      setVehicleVariantList([]);
                                                    }}
                                                    placeholder={
                                                      "Select Vehicle Year"
                                                    }
                                                    onInputChange={
                                                      handleInputSelectedChangeComYearList
                                                    }
                                                    inputSelctedValue={
                                                      inputSelctedeYearValue
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <Select
                                                    className="my-select-v"
                                                    options={VehicleMakeList}
                                                    value={
                                                      VehicleMakeList.find(
                                                        (item) =>
                                                          item.value ===
                                                          vehiclePartsData.vehicle_make
                                                      ) || null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      setVehiclePartsData(
                                                        (prev) => ({
                                                          ...prev,
                                                          vehicle_make:
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "",
                                                          vehicle_model: "",
                                                          vehicle_variant: "",
                                                        })
                                                      );
                                                      setVehicleModalList([]);
                                                      setVehicleVariantList([]);
                                                    }}
                                                    isSearchable={true}
                                                    onInputChange={
                                                      handleInputSelectedChangeComMakeList
                                                    }
                                                    inputSelctedValue={
                                                      inputSelctedeMakeValue
                                                    }
                                                    placeholder={
                                                      "Select Vehicle Make"
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <Select
                                                    className="my-select-v"
                                                    options={
                                                      vehiclePartsData.vehicle_make
                                                        ? VehicleModalList
                                                        : [
                                                            {
                                                              value: "all",
                                                              label: "All",
                                                            },
                                                            ...VehicleModalList,
                                                          ]
                                                    }
                                                    value={
                                                      vehiclePartsData.vehicle_make
                                                        ? VehicleModalList.find(
                                                            (item) =>
                                                              item.value ===
                                                              vehiclePartsData.vehicle_model
                                                          )
                                                        : null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      setVehiclePartsData(
                                                        (prev) => ({
                                                          ...prev,
                                                          vehicle_model:
                                                            selectedOption
                                                              ? selectedOption.value
                                                              : "all",
                                                          vehicle_variant:
                                                            "all", // Reset variant when model changes
                                                        })
                                                      );
                                                      setVehicleVariantList([]);
                                                    }}
                                                    isSearchable={true}
                                                    onInputChange={
                                                      handleInputSelectedChangeModalList
                                                    }
                                                    inputSelctedValue={
                                                      inputSelctedeModalValue
                                                    }
                                                    placeholder={
                                                      "Select Vehicle Model"
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <Select
                                                    className="my-select-v"
                                                    options={
                                                      vehiclePartsData.vehicle_model ||
                                                      vehiclePartsData.vehicle_make
                                                        ? VehicleVariantList
                                                        : [
                                                            {
                                                              value: "all",
                                                              label: "All",
                                                            },
                                                            ...VehicleVariantList,
                                                          ]
                                                    }
                                                    value={
                                                      vehiclePartsData.vehicle_model
                                                        ? VehicleVariantList.find(
                                                            (item) =>
                                                              item.value ===
                                                              vehiclePartsData.vehicle_variant
                                                          )
                                                        : vehiclePartsData.vehicle_make
                                                        ? {
                                                            value: "all",
                                                            label: "All",
                                                          }
                                                        : null
                                                    }
                                                    onChange={(
                                                      selectedOption
                                                    ) =>
                                                      setVehiclePartsData({
                                                        ...vehiclePartsData,
                                                        vehicle_variant:
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : "all", // Reset variant
                                                      })
                                                    }
                                                    isSearchable={true}
                                                    onInputChange={
                                                      handleInputSelectedChangeComVariantList
                                                    }
                                                    inputSelctedValue={
                                                      inputSelctededVariantValue
                                                    }
                                                    placeholder={
                                                      "Select Vehicle Variant"
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </th>

                                            <th>
                                              <div
                                                className="input-div SelectV"
                                                style={{ width: "190px" }}
                                              >
                                                <div className="col-md-12">
                                                  <input
                                                    className="form-control input-search"
                                                    type="text"
                                                    name="notes"
                                                    value={
                                                      vehiclePartsData.notes
                                                    }
                                                    onChange={
                                                      handleInputChangeComp
                                                    }
                                                    placeholder={t("notes")}
                                                  />
                                                </div>
                                              </div>
                                            </th>
                                            <th>
                                              <div
                                                className="addBtn"
                                                style={{ cursor: "pointer" }}
                                                onClick={handleAddCompatible}
                                              >
                                                <i className="bi bi-plus-lg"></i>
                                              </div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {partsData?.parts_associate?.map(
                                            (item, index) => (
                                              <tr key={index}>
                                                <td>
                                                  <td>
                                                    <input
                                                      type="checkbox"
                                                      checked={selectedRows?.parts_associate?.some(
                                                        (selected) =>
                                                          selected.vehicle_make ===
                                                            item.vehicle_make &&
                                                          selected.vehicle_model ===
                                                            item.vehicle_model &&
                                                          selected.vehicle_variant ===
                                                            (item.vehicle_variant ||
                                                              0) &&
                                                          selected.vehicle_year ===
                                                            item.vehicle_year
                                                      )}
                                                      onChange={(e) => {
                                                        const rowData = {
                                                          vehicle_type:
                                                            item.vehicle_type ||
                                                            0,
                                                          vehicle_year:
                                                            item.vehicle_year ||
                                                            0,
                                                          vehicle_make:
                                                            item.vehicle_make ||
                                                            0,
                                                          vehicle_model:
                                                            item.vehicle_model ||
                                                            0,
                                                          vehicle_variant:
                                                            item.vehicle_variant ||
                                                            0,
                                                          notes:
                                                            item.notes || "",
                                                        };

                                                        setSelectedRows(
                                                          (prev) => {
                                                            const current =
                                                              prev.parts_associate ||
                                                              [];

                                                            if (
                                                              e.target.checked
                                                            ) {
                                                              if (
                                                                !current.some(
                                                                  (selected) =>
                                                                    selected.vehicle_make ===
                                                                      rowData.vehicle_make &&
                                                                    selected.vehicle_model ===
                                                                      rowData.vehicle_model &&
                                                                    selected.vehicle_variant ===
                                                                      rowData.vehicle_variant &&
                                                                    selected.vehicle_year ===
                                                                      rowData.vehicle_year
                                                                )
                                                              ) {
                                                                return {
                                                                  ...prev,
                                                                  parts_associate:
                                                                    [
                                                                      ...current,
                                                                      rowData,
                                                                    ],
                                                                };
                                                              }
                                                              return prev;
                                                            } else {
                                                              const updated =
                                                                current.filter(
                                                                  (selected) =>
                                                                    !(
                                                                      selected.vehicle_make ===
                                                                        rowData.vehicle_make &&
                                                                      selected.vehicle_model ===
                                                                        rowData.vehicle_model &&
                                                                      selected.vehicle_variant ===
                                                                        rowData.vehicle_variant &&
                                                                      selected.vehicle_year ===
                                                                        rowData.vehicle_year
                                                                    )
                                                                );
                                                              return {
                                                                ...prev,
                                                                parts_associate:
                                                                  updated,
                                                              };
                                                            }
                                                          }
                                                        );
                                                      }}
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  </td>
                                                </td>

                                                <td>
                                                  {item.vehicle_type?.label}
                                                </td>
                                                <td>
                                                  {item.vehicle_year?.label}
                                                </td>
                                                <td>
                                                  {item.vehicle_make?.label ||
                                                    "All"}
                                                </td>
                                                <td>
                                                  {item.vehicle_model?.label}
                                                </td>
                                                <td>
                                                  {item.vehicle_variant
                                                    ?.label || "All"}
                                                </td>
                                                <td>{item.notes || "-"}</td>
                                                <td>
                                                  <Button
                                                    type="button"
                                                    className="btn-danger-delete"
                                                    onClick={() =>
                                                      handleRemoveCompatible(
                                                        index
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-trash3"></i>
                                                  </Button>
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </Table>
                                    </div>
                                  </div>

                                  <div className="back-footer">
                                    <div className="back-next back-next-custom">
                                      <div className="row">
                                        <div className="col">
                                          <button
                                            type="button"
                                            className="next-button btn btn-secondary ms-0"
                                            onClick={() => setKey("references")}
                                          >
                                            <i className="bi bi-arrow-left"></i>{" "}
                                            {t("back")}
                                          </button>
                                        </div>

                                        <div className="col nxt-btn mr-0">
                                          <Button
                                            className="next-button"
                                            type="button"
                                            onClick={handleSubmit}
                                          >
                                            {t("save")}{" "}
                                            <i className="bi bi-arrow-right"></i>
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modifyOemModal} size="xxl">
        <ModalHeader>{t("oem_references")}</ModalHeader>
        <div className="col-md-6">
          {t("priceOEM")} : € {structureOemList?.decode?.priceOEM || 0}
        </div>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === "1" ? "active" : ""}
                  onClick={() => toggleTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsIAM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "2" ? "active" : ""}
                  onClick={() => toggleTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsOEM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "3" ? "active" : ""}
                  onClick={() => toggleTab("3")}
                  style={{ cursor: "pointer" }}
                >
                  {t("VehiclesCompatibles")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {loadingStructureOem ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">{t("loading")}</span>
              </div>
            </div>
          ) : (
            <TabContent activeTab={activeTab} className="pt-3">
              <TabPane tabId="1">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleOpenProductConfirm}
                      style={{
                        width: "110px",
                        marginBottom: "9px",
                        marginTop: "-25px",
                      }}
                    >
                      {t("products")} <i className="bi bi-check2"></i>
                    </button>
                  </div>
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsIAM
                                      ?.length > 0 &&
                                    selectedVehicleOEMData?.iem_list?.length ===
                                      structureOemList?.decode?.equivalentsIAM
                                        ?.length
                                  }
                                  onChange={handleCheckAll}
                                />
                              </th>
                              <th>{t("brandName")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("manufacter")}</th>
                              <th>{t("reference")}</th>
                              <th>{t("action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsIAM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsIAM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedVehicleOEMData?.iem_list?.some(
                                          (i) => i.productID === item.productID
                                        )}
                                        onChange={() =>
                                          handleCheck(item.productID)
                                        }
                                      />
                                    </td>
                                    <td>{item?.brandName}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.reference}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-block btn-primary"
                                        onClick={(e) => {
                                          setProductVehicleId(item);
                                          setModifyProductModal(true);
                                        }}
                                        style={{
                                          width: "45px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <i className="bi bi-gear"></i>{" "}
                                      </button>{" "}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="2">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsOEM
                                      ?.length > 0 &&
                                    selectedVehicleOEMData?.oem_list?.length ===
                                      structureOemList?.decode?.equivalentsOEM
                                        ?.length
                                  }
                                  onChange={handleCheckAllOEM}
                                />
                              </th>
                              <th>{t("manufacter")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("reference")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsOEM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsOEM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedOEMIndices.includes(
                                          index
                                        )}
                                        onChange={() => handleCheckOEM(index)}
                                      />
                                    </td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.reference}</td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsOEM
                                      ?.length > 0 &&
                                    selectedOEMIndices.length ===
                                      structureOemList.decode.equivalentsOEM
                                        .length
                                  }
                                  onChange={handleCheckAllOEM}
                                />
                              </th>
                              <th>{t("vehicle_make_description")}</th>
                              <th>{t("vehicle_model_description")}</th>
                              <th>{t("vehicle_variant_description")}</th>
                              <th>{t("vehicle_variant_end_production")}</th>
                              <th>{t("vehicle_variant_init_production")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vehicleCompatiblesList?.length > 0 ? (
                              vehicleCompatiblesList?.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedVehicleOEMData?.vehicle_compatible_list?.some(
                                        (i) => i.variantID === item.variantID
                                      )}
                                      onChange={() =>
                                        handleCompatibleCheck(item.variantID)
                                      }
                                    />
                                  </td>
                                  <td>{item?.vehicle_make_description}</td>
                                  <td>{item?.vehicle_model_description}</td>
                                  <td>{item?.vehicle_variant_description}</td>
                                  <td>
                                    {item?.vehicle_variant_end_production}
                                  </td>
                                  <td>
                                    {item?.vehicle_variant_init_production}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSelectRef}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("Select")} <i className="bi bi-check2"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangeOemRefClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyProductModal} size="xxl">
        <ModalHeader>{t("product_details")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div
                    className="row"
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("product_name")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("reference")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.reference || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("supplier")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.supplier || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("eanNumbers")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product?.eanNo
                          ?.eanNumbers || 0}
                      </h6>
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("allSpecifications")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("criteriaName")}</th>
                                <th>{t("criteriaValue")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.allSpecifications?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.allSpecifications?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.criteriaName}</td>
                                      <td>{item?.criteriaValue}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("crossOEM")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("fullReference")}</th>
                                <th>{t("manufacter")}</th>
                                <th>{t("reference")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.crossOEM?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.crossOEM?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.fullReference}</td>
                                      <td>{item?.manufacter}</td>
                                      <td>{item?.reference}</td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("vehiclesCompatibles")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("vehicle_make_description")}</th>
                                <th>{t("vehicle_model_description")}</th>
                                <th>{t("vehicle_variant_description")}</th>
                                <th>{t("vehicle_variant_end_production")}</th>
                                <th>{t("vehicle_variant_init_production")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.vehiclesCompatibles?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.vehiclesCompatibles?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.vehicle_make_description}</td>
                                      <td>{item?.vehicle_model_description}</td>
                                      <td>
                                        {item?.vehicle_variant_description}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_end_production}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_init_production}
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductDetailsModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyConfirmModal}>
        <ModalHeader>{t("replace_the_vehicle_compatibles")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("are_you_sure_you_want_to_replace_the_vehicle_compatibles_data")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductConfirmClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("No")} <i className="bi bi-x-lg"></i>
          </button>

          {!loadingCompatible && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={handleSubmitVehicleComProduct}
            >
              {t("yes")} <i className="bi bi-x-lg"></i>
            </button>
          )}
          {loadingCompatible && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AutoFillVehicle;
